// @flow

import React from 'react';
import { observer } from 'mobx-react';
import { css } from 'glamor';

const genreRule = css({
    display: 'inline-block',
});

const iconRule = css({
    marginRight: '10px',
});

const svgIcon = css({
    width: '15px',
    height: '15px',
    display: 'inline-block',
    top: '-1px',
    lineHeight: '10px',
    position: 'relative',
});

const labelRule = css({
    color: 'inherit',
});

@observer
export default class Staff extends React.Component {
    props: {
        genre: Object,
    };

    render() {
        const { genre } = this.props;
        const Icon = genre.image && genre.image.secure_url ?
            (<span { ...iconRule }>
                  <img { ...svgIcon } src={ genre.image.secure_url } />
              </span>) :
            null;

        return (
            <span { ...genreRule }>
                {Icon}
                <span { ...labelRule }>
                    {genre.name}
                </span>
            </span>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/content/game/Genre/index.js